// extracted by mini-css-extract-plugin
export default {"font-renta":"RentaTasks_font-renta__6bYRa","wizardContent":"RentaTasks_wizardContent__kzcQe"};